import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary

import {
  BASE_APPROVAL_URL,
  BASE_URL,
  BASE_AUTOCOMPLETE_URL,
} from '../apiConfig';

export const fetchRequestTypes = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_APPROVAL_URL}/category`,
  );
  return response;
};

export const fetchMyRequests = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/my-requests`,
    payload,
  );
  return response;
};

export const fetchMyApprovals = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/my-approvals`,
    payload,
  );
  return response;
};

export const fetchTableColumnValues = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-table-column-values`,
    payload,
  );
  return response;
};

export const cancelRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/cancel-request`,
    payload,
  );
  return response;
};

export const approveRejectRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/approve-reject-request`,
    payload,
  );
  return response;
};

export const approveRejectRequestList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/approve-reject-request/list`,
    payload,
  );
  return response;
};

export const cancelRequestList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_APPROVAL_URL}/cancel-request/list`,
    payload,
  );
  return response;
};

export const getMyapprovalsRequestCount = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_APPROVAL_URL}/my-approvals-requests/count`,
  );
  return response;
};
